import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { WierszRozmowy } from "../../components/recenzja/WierszRozmowy.js";
import { Banner } from "../../components/ui/Banner.js";
import { Button } from "../../components/ui/Button.js";
import { Card } from "../../components/ui/Card.js";
import { StanBledu, StanLadowania, StanPusty } from "../../components/ui/stany.js";
import { tytulListyRecenzji, useTytulStrony } from "../../hooks/useTytulStrony.js";
import type { KontekstUkladuRecenzji } from "./UkladRecenzji.js";

/**
 * Strona glowna linku (/r/:token): powitanie, jedno zdanie instrukcji i lista rozmow do przejrzenia z postepem.
 * Cztery stany (P-6): ladowanie, blad, pusto i dane. Link nieprawidlowy obsluguje uklad (UkladRecenzji).
 */
export function ListaRecenzjiPage(): React.JSX.Element {
  const { token, info } = useOutletContext<KontekstUkladuRecenzji>();
  const { dane, blad, odswiez } = info;
  useTytulStrony(dane ? tytulListyRecenzji(dane.etykieta) : null);

  // Powrot z rozmowy: lista ma pokazac swiezy postep. Stare dane zostaja na ekranie do czasu nowych (bez migotania),
  // a pierwsze wejscie niczego nie odswieza, bo uklad wlasnie je pobiera.
  useEffect(() => {
    if (info.dane !== null) odswiez();
    // Tylko przy wejsciu na strone.
  }, []);

  const rozmowy = dane?.rozmowy ?? [];
  const pierwszaDoZrobienia = rozmowy.findIndex((r) => r.stan !== "PRZEJRZANA");

  return (
    <>
      <h1 className="page-title">Dzień dobry</h1>
      <p className="page-lead">
        Przy każdym wskazaniu modelu zaznacz, czy się zgadzasz, a tam, gdzie nic nie ruszasz, zakładamy zgodę.
      </p>

      <Banner
        wariant="info"
        tekst="Wszystko zapisuje się samo. Możesz zamknąć kartę i wrócić tym samym linkiem, kiedy chcesz."
      />

      <Card tytul={dane ? `Rozmowy do przejrzenia (${rozmowy.length})` : "Rozmowy do przejrzenia"}>
        {dane === null && blad === null && <StanLadowania tekst="Wczytuję rozmowy..." />}

        {dane === null && blad !== null && (
          <StanBledu
            szczegol={blad}
            akcja={
              <Button wariant="secondary" onClick={odswiez}>
                Spróbuj ponownie
              </Button>
            }
          />
        )}

        {dane !== null && rozmowy.length === 0 && (
          <StanPusty
            tytul="Pod tym linkiem nie ma jeszcze rozmów"
            opis="Odezwij się do osoby, która przesłała Ci link."
          />
        )}

        {dane !== null && rozmowy.length > 0 && (
          <>
            <ul className="rowlist rec-lista" role="list">
              {rozmowy.map((rozmowa, i) => (
                <WierszRozmowy key={rozmowa.id} token={token} rozmowa={rozmowa} doZrobienia={i === pierwszaDoZrobienia} />
              ))}
            </ul>
            <p className="field-hint rec-lista__nota">
              Wolisz Worda? Plik z kolumnami na ocenę i komentarz pobierzesz przy każdej rozmowie przyciskiem „Word”.
            </p>
          </>
        )}
      </Card>
    </>
  );
}
